export default {
  props: ['courses'],
  template: '#course_progress_widget_template',
};